import { useHasInternalNewsquawkUserRole } from "@/hooks/useHasInternalNewsquawkUserRole";
import { useGetAppRoles } from "@/hooks/useGetAppRoles";
import {
  BackendSource,
  backendSources,
  isSourceAccessible,
  sourceLabels,
} from "@/shared/api/firehose";
import { useMemo } from "react";

// Sources that show real supplier names to all users (not obfuscated)
export const publicLabelSources: BackendSource[] = [
  "stocks-one",
  "stocks-two",
  "stocks-three",
  "stocks-four",
  "stocks-four-filings",
  "stocks-four-fedspeak",
  "stocks-four-general",
];

export const useFirehoseSources = () => {
  const hasAccessInternal = useHasInternalNewsquawkUserRole();
  const roles = useGetAppRoles();

  const sources = useMemo(
    () =>
      backendSources
        .filter((source) =>
          isSourceAccessible(source, roles, hasAccessInternal)
        )
        .map((source, idx) => ({
          id: idx,
          source: source,
          label:
            hasAccessInternal || publicLabelSources.includes(source)
              ? sourceLabels[source]
              : source.replaceAll("-", " "),
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [hasAccessInternal, roles]
  );

  return sources;
};
